import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { HelpersUtil } from 'src/app/shared/utils/helpers.util';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private requestCount = 0; // Contador de requisições

  constructor(private loadingCtrl: LoadingController) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request);
    //desativei esses códigos para a página fluir melhor ( cleverton em 10 de nov )
    if (request.headers.has('X-Skip-Loading-Interceptor')) {
      return next.handle(request);
    } else {
      if (this.requestCount === 0) {
        HelpersUtil.executeAfterDelay(async () => await this.showLoading(), 50);
      }

      this.requestCount++;

      return next.handle(request).pipe(
        catchError((err) => {
          if (err instanceof HttpErrorResponse) {
            // Tratar erro aqui
          }
          return throwError(err);
        }),
        finalize(() => {
          this.requestCount--;

          if (this.requestCount === 0) {
            HelpersUtil.executeAfterDelay(async () => await this.hideLoading(), 50);
          }
        })
      );
    }
  }

  private async showLoading() {
    const loading = await this.loadingCtrl.create({ duration: 10000, backdropDismiss: true });
    await loading.present();
  }

  private async hideLoading() {
    await this.loadingCtrl.dismiss();
  }
}
